export enum ChecklistDocumentAction {
  Uploaded = 'uploaded',
  Reviewed = 'reviewed',
  Deleted = 'deleted',
}
